<script lang="ts" setup>
import logo from "@/assets/image/icm-logo.svg";
import instagram from "@/assets/image/icons/instagram_icon.svg";
</script>

<template>
  <footer
    class="bg-[linear-gradient(126.83deg,_#101010_33.34%,_rgba(16,16,16,0.6)_98.79%),url('@/assets/image/hero/hero-solarni-paneli.png')] bg-cover bg-bottom-right bg-no-repeat px-4 py-25 md:py-50"
  >
    <div class="mx-auto max-w-screen-xl">
      <div class="flex flex-col space-y-12 [@media(min-width:1307px)]:flex-row">
        <div class="flex w-full flex-col [@media(min-width:1307px)]:max-w-[464px]">
          <div class="w-full max-w-[358px]">
            <router-link :to="{ name: 'HomePage' }" aria-label="Return to Home Page">
              <img class="mb-3 w-full" :src="logo" alt="ICM Elektro" loading="lazy" />
            </router-link>
          </div>
          <div class="max-w-[464px]">
            <footer-paragraph class="self-left mb-3 py-3" :text="$t('app.footer.text')"></footer-paragraph>
            <a
              href="https://www.instagram.com/icm_elektro__/"
              target="_blank"
              class="block h-[32px] w-[32px] hover:opacity-80"
              rel="noopener noreferrer"
            >
              <img class="h-full w-full" :src="instagram" alt="instagram" loading="lazy" />
            </a>
          </div>
        </div>
        <div class="space-y-12 pt-[45px] md:flex [@media(min-width:1307px)]:flex-1 [@media(min-width:1307px)]:justify-around">
          <div class="space-y-6 md:w-[50%] [@media(min-width:1307px)]:w-fit">
            <footer-paragraph class="font-semibold" :text="$t('app.base.contact')"></footer-paragraph>
            <a href="tel:+38162491909" class="text-text-white block leading-[120%] tracking-normal hover:opacity-90 md:text-xl"
              >062/491909</a
            >
            <a href="mailto:info@icmelektro.com" class="text-text-white block leading-[120%] tracking-normal hover:opacity-90 md:text-xl"
              >info@icmelektro.com</a
            >
            <footer-paragraph :text="$t('app.footer.city')"></footer-paragraph>
          </div>
          <div class="space-y-6 md:w-[50%] [@media(min-width:1307px)]:w-fit">
            <footer-paragraph class="font-semibold" :text="$t('app.base.info')"></footer-paragraph>
            <footer-paragraph text="PIB 108618497     "></footer-paragraph>
            <footer-paragraph text="MB 63578339"></footer-paragraph>
          </div>
        </div>
      </div>
      <div class="w-ful my-8 h-[1px] bg-[#494E5B]"></div>
      <div class="text-text-grey flex flex-wrap justify-between space-y-3 text-[13px] md:text-base">
        <div>© 2025 ICM Elektro all rights reserved</div>
        <div>
          created by
          <a
            href="https://enonsolutions.com"
            target="_blank"
            class="hover:opacity-80"
            rel="noopener noreferrer"
            title="ENON Solutions - Delivering software projectson time, every time!"
            >ENON Solutions</a
          >. Powered by
          <a
            target="_blank"
            href="https://marsengine.net"
            class="hover:opacity-80"
            rel="noopener noreferrer"
            title="MARS Engine - Collaborative dev environment that scales"
            >MARS Engine</a
          >
        </div>
      </div>
    </div>
  </footer>
</template>
